import { PAYMENT_METHOD } from '../constants/paymentMethod';

type Hook = (params: PaymentHookParams) => PaymentHookResult | void;
type HookKey =
  | PAYMENT_METHOD
  | 'GATEWAY_REQUIRES_ACTION'
  | 'EFTPOS_STATUS_UPDATE'
  | 'LOYALTY_PAYMENT_UPDATE'
  | 'MIN_CC_AMOUNT_NOT_MET'
  | 'PRE_FINALISE_PAYMENT_REQUEST'
  | 'TRANSACTION_COMPLETED'
  | 'TERMINAL_UNAVAILABLE'
  | 'CANCEL_TRANSACTION'
  | 'WINDCAVE_UPDATE'
  | 'SIGNATURE_VOID'
  | 'CHECK_EFTPOS_TXN';
type HookStore = Record<HookKey, Hook | undefined>;

export default class PaymentHooks {
  static hooks: HookStore = {} as HookStore;

  static subscribe(hookName: HookKey, handler: Hook) {
    PaymentHooks.hooks[hookName] = handler;
  }

  static clear(hookName: HookKey) {
    PaymentHooks.hooks[hookName] = undefined;
  }

  static get(hookName: HookKey) {
    return PaymentHooks.hooks[hookName];
  }
}
